import { render, staticRenderFns } from "./W8BENList.vue?vue&type=template&id=1f38ea52&scoped=true&"
import script from "./W8BENList.vue?vue&type=script&lang=ts&"
export * from "./W8BENList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38ea52",
  null
  
)

export default component.exports